import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../auth/index.js';

export function VerifySessionPage(): ReactElement {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    void api
      .confirmAgeVerification()
      .then(async () => {
        // Warm status so shell banner / gates see VERIFIED after navigation.
        await api.getComplianceStatus().catch(() => null);
        if (cancelled) {
          return;
        }
        setDone(true);
        void navigate('/wallet', { replace: true });
      })
      .catch(() => {
        if (!cancelled) {
          setError('Verification could not be completed.');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [api, navigate]);

  return (
    <section>
      <h1 style={{ fontFamily: 'var(--fm-font-heading)', marginTop: 0 }}>ID verification</h1>
      {done ? (
        <>
          <p>Verification complete. Redirecting…</p>
          <Link to="/wallet">Continue to wallet</Link>
        </>
      ) : (
        <p style={{ color: 'var(--fm-color-text-muted)' }}>
          {error ?? 'Confirming verification (dev stub)…'}
        </p>
      )}
    </section>
  );
}
